import axios from 'axios';
import Environment from '../../utils/Environment';
import { StoreOrderDTO } from '../../common/tab/dto/StoreOrderDTO';

interface StoreOrderResponse {
  infoMsg?: string;
  errorMsg?: string;
}

const submitStoreOrder = async (
  form: StoreOrderDTO,
  setIsLoading: (value: boolean) => void
): Promise<StoreOrderResponse> => {
  const apiUrl = Environment.getStoreOrderPublishAPI();
  setIsLoading(true);

  try {
    const response = await axios.post(apiUrl, form, {
      responseType: 'blob',
      headers: {
        'Accept': 'application/json, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Content-Type': 'application/json',
      },
    });

    const contentType = response.headers['content-type'] ?? '';
    const messageHeader = response.headers['x-message'] ?? '';

    if (contentType.includes('application/json')) {
      const text = await response.data.text();
      const json = JSON.parse(text);
      return {
        infoMsg: json.infoMsg || undefined,
        errorMsg: json.errorMsg || undefined,
      };
    }

    if (contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'store-order.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      return {
        infoMsg: messageHeader || 'Store order published successfully. Store Order Status report downloaded successfully.',
      };
    }

    return { errorMsg: 'Unsupported response type from server.' };
  } catch (err: any) {
    const errorBlob = err?.response?.data;
    const contentType = err?.response?.headers?.['content-type'] ?? '';

    if (errorBlob && contentType.includes('application/json')) {
      const text = await errorBlob.text();
      try {
        const errorJson = JSON.parse(text);
        return {
          errorMsg: errorJson.errorMsg || errorJson.message || 'Unknown error occurred.',
        };
      } catch {
        return { errorMsg: 'Failed to parse error response.' };
      }
    }

    return {
      errorMsg: err.message || 'Unknown error occurred.',
    };
  } finally {
    setIsLoading(false);
  }
};

export default submitStoreOrder;
